/**
 * Created by pablo on 8/22/17.
 */

import { CUIT } from './helpers/cuit';
import cookieHelper from "./paymentMethods/src/helpers/cookieHelper";
import AfipHelper   from './helpers/afip';

(function ($, undefined) {
    'use strict';

    //binding
    $("#erp_combos").change(function() {

        $(".companies_select").css("display", "none")

        let str = '';
        $( "#erp_combos option:selected" ).each(function() {
            str += $( this ).val();
        });
        $("#"+str+"_companies").css("display", "block")
    });

})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/companies.js